export const getTextFromHtml = (content: string) => {
  const div = document.createElement("div")
  div.innerHTML = content.replaceAll("</p><p>", " ")
  return (div.textContent || div.innerText)
    .replace(/[\n\r]+|[\s]{2,}/g, " ")
    .trim()
}
